// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { useParams } from "react-router-dom";

// const BASE_URL = "https://ecom.cyberathon.com";

// function OfferDetails() {

//   const { id } = useParams();
//   const [offer, setOffer] = useState(null);

//   useEffect(() => {

//     const fetchOffer = async () => {

//       try {

//         const res = await axios.post(
//           `${BASE_URL}/index.php/Api/get_card_section_by_id`,
//           { id: id }   // payload
//         );

//         console.log("API Response:", res.data);

//         if (res.data.status === "true") {
//           setOffer(res.data.data);
//         }

//       } catch (error) {
//         console.log("API Error:", error);
//       }

//     };

//     fetchOffer();

//   }, [id]);

//   if (!offer) {
//     return (
//       <div style={{textAlign:"center",padding:"80px"}}>
//         <h3>Loading...</h3>
//       </div>
//     );
//   }

//   return (

//     <div className="container py-5">

//       <div className="row align-items-center">

//         {/* IMAGE */}

//         <div className="col-md-6">

//           <img
//             src={`${BASE_URL}/${offer.image}`}
//             alt={offer.title}
//             className="img-fluid rounded shadow"
//           />

//         </div>

//         {/* CONTENT */}

//         <div className="col-md-6">

//           <span className="badge bg-danger mb-3">
//             {offer.discount} OFF
//           </span>

//           <h2>{offer.title}</h2>

//           <p>{offer.description}</p>

//           <p className="text-muted text-decoration-line-through">
//             ₹{offer.old_price}
//           </p>

//           <h4 className="fw-bold text-success">
//             ₹{offer.current_price}
//           </h4>

//         </div>

//       </div>

//     </div>

//   );
// }

// export default OfferDetails;




// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import Layout from "../../Layout/Layout";
// import FooterNew from "../../Layout/FooterNew";
// import styles from "./OfferDetails.module.css";
// const BASE_URL = "https://ecom.cyberathon.com";

// function OfferDetails() {

//   const { id } = useParams();
//   const navigate = useNavigate();

//   const [offer, setOffer] = useState({});
//   const [qty, setQty] = useState(1);

//   useEffect(() => {
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   }, []);

//   useEffect(() => {

//     const fetchOffer = async () => {

//       try {

//         const res = await axios.post(
//           `${BASE_URL}/index.php/Api/get_card_section_by_id`,
//           { id }
//         );

//         if (res.data.status === "true") {
//           setOffer(res.data.data);
//         }

//       } catch (error) {
//         console.log(error);
//       }

//     };

//     fetchOffer();

//   }, [id]);


//   /* QTY CONTROLS */

//   const increaseQty = () => setQty(prev => prev + 1);

//   const decreaseQty = () => {
//     if (qty > 1) setQty(prev => prev - 1);
//   };


//   /* BUY NOW */

//   const handleBuyNow = () => {

//     navigate("/Bill");

//   };


//   /* ADD TO CART */

//   const handleAddToCart = () => {

//     navigate("/Cart");

//   };


//   if (!offer?.title) {

//     return (
//       <div style={{ textAlign: "center", padding: "120px" }}>
//         <h3>Loading...</h3>
//       </div>
//     );

//   }


//   return (
//     <>
//       <Layout />

//       <div className="container-fluid pt-5 pb-3">

//         <div className="row align-items-start">

//           {/* IMAGE SECTION */}

//           <div className="col-12 col-lg-5 col-md-6 position-relative">

//             <div className="text-center border rounded p-4 shadow-sm">

//               <img
//                 src={`${BASE_URL}/${offer.image}`}
//                 alt={offer.title}
//                 className="img-fluid"
//                 style={{
//                   maxHeight: "420px",
//                   objectFit: "contain"
//                 }}
//               />

//             </div>

//           </div>



//           {/* DETAILS */}

//           <div className="col-12 col-lg-7 col-md-6 p-5 pt-md-0 pt-sm-3">

//             <span className="badge bg-danger mb-3 fs-6">
//               {offer.discount} OFF
//             </span>

//             <h2 className="fw-bold">
//               {offer.title}
//             </h2>

//             {/* <p className="text-muted">
//               {offer.description}
//             </p> */}

//             <hr />



//             {/* PRICE */}

//             <div className="d-flex align-items-center mb-3">

//               <h1 className="text-success me-3 fw-bold mb-0">
//                 ₹{offer.current_price * qty}
//               </h1>

//               <h4 className="text-decoration-line-through text-muted mb-0">
//                 ₹{offer.old_price}
//               </h4>

//             </div>



//             {/* QTY */}

//             <div className="d-flex align-items-center mb-4">

//               <button
//                 className="btn btn-light border"
//                 onClick={decreaseQty}
//               >
//                 −
//               </button>

//               <input
//                 type="text"
//                 value={qty}
//                 className="mx-3 text-center"
//                 style={{
//                   width: "60px",
//                   border: "1px solid #ddd",
//                   borderRadius: "5px"
//                 }}
//                 readOnly
//               />

//               <button
//                 className="btn btn-light border"
//                 onClick={increaseQty}
//               >
//                 +
//               </button>

//             </div>



//             {/* BUTTONS */}

//             <div className="row g-2">

//               <div className="col-6 col-md-auto">

//                 <button
//                   className="w-100 border-0 rounded-3 bg-dark text-light py-3 px-5"
//                   onClick={handleAddToCart}
//                 >
//                   Add to Cart
//                 </button>

//               </div>

//               <div className="col-6 col-md-auto">

//                 <button
//                   className="w-100 border-0 rounded-3 bg-success text-light py-3 px-5"
//                   onClick={handleBuyNow}
//                 >
//                   Buy Now
//                 </button>

//               </div>

//             </div>



//             {/* DELIVERY INFO */}

//             <div className="pt-4">

//               <table className="table table-bordered table-hover">

//                 <tbody>

//                   <tr>
//                     <td>Delivery within 3-5 working days</td>
//                   </tr>

//                   <tr>
//                     <td>Money Back Guarantee</td>
//                   </tr>

//                   <tr>
//                     <td>Secure Payment</td>
//                   </tr>

//                 </tbody>

//               </table>

//             </div>

//           </div>

//         </div>

//       </div>



//       {/* DESCRIPTION */}

//       <div className="container-fluid px-5 pb-5">

//         <h3 className="text-decoration-underline">
//           Description
//         </h3>

//         <hr />

//         <p style={{ textAlign: "justify" }}>
//           {offer.description}
//         </p>

//       </div>

//       <FooterNew />

//     </>
//   );

// }

// export default OfferDetails;


// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import Layout from "../../Layout/Layout";
// import FooterNew from "../../Layout/FooterNew";
// import styles from "./OfferDetails.module.css";

// const BASE_URL = "https://ecom.cyberathon.com";

// function OfferDetails() {

//   const { id } = useParams();
//   const navigate = useNavigate();

//   const [offer, setOffer] = useState({});
//   const [qty, setQty] = useState(1);

//   useEffect(() => {
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   }, []);

//   useEffect(() => {

//     const fetchOffer = async () => {

//       try {

//         const res = await axios.post(
//           `${BASE_URL}/index.php/Api/get_card_section_by_id`,
//           { id }
//         );

//         if (res.data.status === "true") {
//           setOffer(res.data.data);
//         }

//       } catch (error) {
//         console.log(error);
//       }

//     };

//     fetchOffer();

//   }, [id]);


//   const increaseQty = () => setQty(prev => prev + 1);

//   const decreaseQty = () => {
//     if (qty > 1) setQty(prev => prev - 1);
//   };


//   const handleBuyNow = () => {
//     navigate("/Bill");
//   };

//   const handleAddToCart = () => {
//     navigate("/Cart");
//   };


//   if (!offer?.title) {
//     return (
//       <div className={styles.loading}>
//         <h3>Loading...</h3>
//       </div>
//     );
//   }


//   return (
//     <>
//       <Layout />

//       <div className={`container-fluid pt-5 pb-3 ${styles.offerContainer}`}>

//         <div className="row align-items-start">

//           {/* IMAGE */}

//           <div className="col-12 col-lg-5 col-md-6">

//             <div className={styles.imageBox}>

//               <img
//                 src={`${BASE_URL}/${offer.image}`}
//                 alt={offer.title}
//                 className="img-fluid"
//               />

//             </div>

//           </div>


//           {/* DETAILS */}

//           <div className="col-12 col-lg-7 col-md-6 p-5 pt-md-0 pt-sm-3">

//             <span className={`badge bg-danger mb-3 fs-6 ${styles.discount}`}>
//               {offer.discount} OFF
//             </span>

//             <h2 className={styles.title}>
//               {offer.title}
//             </h2>

//             <hr />


//             {/* PRICE */}

//             <div className={styles.priceRow}>

//               <h1 className={styles.currentPrice}>
//                 ₹{offer.current_price * qty}
//               </h1>

//               <h4 className={styles.oldPrice}>
//                 ₹{offer.old_price}
//               </h4>

//             </div>


//             {/* QTY */}

//             <div className={styles.qtyWrapper}>

//               <button
//                 className={styles.qtyBtn}
//                 onClick={decreaseQty}
//               >
//                 −
//               </button>

//               <input
//                 type="text"
//                 value={qty}
//                 className={styles.qtyInput}
//                 readOnly
//               />

//               <button
//                 className={styles.qtyBtn}
//                 onClick={increaseQty}
//               >
//                 +
//               </button>

//             </div>


//             {/* BUTTONS */}

//             <div className="row g-2 mt-3">

//               <div className="col-6 col-md-auto">

//                 <button
//                   className={styles.cartBtn}
//                   onClick={handleAddToCart}
//                 >
//                   Add to Cart
//                 </button>

//               </div>

//               <div className="col-6 col-md-auto">

//                 <button
//                   className={styles.buyBtn}
//                   onClick={handleBuyNow}
//                 >
//                   Buy Now
//                 </button>

//               </div>

//             </div>


//             {/* DELIVERY */}

//             <div className="pt-4">

//               <table className="table table-bordered table-hover">

//                 <tbody>

//                   <tr>
//                     <td>Delivery within 3-5 working days</td>
//                   </tr>

//                   <tr>
//                     <td>Money Back Guarantee</td>
//                   </tr>

//                   <tr>
//                     <td>Secure Payment</td>
//                   </tr>

//                 </tbody>

//               </table>

//             </div>

//           </div>

//         </div>

//       </div>


//       {/* DESCRIPTION */}

//       <div className={`container-fluid px-5 pb-5 ${styles.description}`}>

//         <h3>Description</h3>

//         <hr />

//         <p>
//           {offer.description}
//         </p>

//       </div>

//       <FooterNew />

//     </>
//   );

// }

// export default OfferDetails;


import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Layout from "../../Layout/Layout";
import FooterNew from "../../Layout/FooterNew";
import { useCart } from "../../../Context/CartContext";

const BASE_URL = "https://ecom.cyberathon.com";

/* Guest cart token */
const getCartToken = () => {
  let token = localStorage.getItem("cart_token");
  if (!token) {
    token = crypto.randomUUID();
    localStorage.setItem("cart_token", token);
  }
  return token;
};

function OfferDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { setCartCount, setShowLogin, setRedirectAfterLogin } = useCart();

  const [offer, setOffer] = useState({});
  const [qty, setQty] = useState(1);
  const [added, setAdded] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  /* Fetch offer */
  useEffect(() => {
    const fetchOffer = async () => {
      try {
        const res = await axios.post(
          `${BASE_URL}/index.php/Api/get_card_section_by_id`,
          { id }
        );
        if (res.data.status === "true") {
          setOffer(res.data.data);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    fetchOffer();
  }, [id]);

  /* Check if already in cart */
  useEffect(() => {
    const checkCart = async () => {
      const userId = sessionStorage.getItem("userId");
      const cartToken = !userId ? localStorage.getItem("cart_token") : null;
      if (!userId && !cartToken) return;
      try {
        const res = await axios.post(`${BASE_URL}/index.php/Api/list_cart`, {
          user_id: userId || null,
          cart_token: cartToken || null,
        });
        if (res.data.status) {
          const ids = res.data.cart_items.map((i) => String(i.prod_id));
          if (ids.includes(String(id))) setAdded(true);
        }
      } catch (err) {
        console.error(err);
      }
    };
    checkCart();
  }, [id]);

  const increaseQty = () => setQty((p) => p + 1);
  const decreaseQty = () => { if (qty > 1) setQty((p) => p - 1); };

  const handleAddToCart = async () => {
    const userId = sessionStorage.getItem("userId");
    const cartToken = !userId ? getCartToken() : null;
    try {
      const res = await axios.post(`${BASE_URL}/index.php/Api/list_cart`, {
        user_id: userId || null,
        cart_token: cartToken,
      });
      let cartItem = null;
      if (res.data.status) {
        cartItem = res.data.cart_items.find((i) => String(i.prod_id) === String(id));
      }
      if (cartItem) {
        await axios.post(`${BASE_URL}/index.php/Api/update_cart`, {
          cart_id: cartItem.cart_id,
          quantity: qty,
          user_id: userId || null,
          cart_token: cartToken,
        });
      } else {
        await axios.post(`${BASE_URL}/index.php/Api/insert_cart`, {
          user_id: userId || null,
          cart_token: cartToken,
          prod_id: id,
          quantity: qty,
        });
        setCartCount((prev) => prev + 1);
      }
      setAdded(true);
    } catch (error) {
      console.error(error);
    }
  };

  const handleBuyNow = async () => {
    const userId = sessionStorage.getItem("userId");
    const cartToken = !userId ? getCartToken() : null;
    try {
      await axios.post(`${BASE_URL}/index.php/Api/insert_cart`, {
        user_id: userId || null,
        cart_token: cartToken,
        prod_id: id,
        quantity: qty,
      });
      if (userId) {
        navigate("/Bill");
      } else {
        setRedirectAfterLogin("/Bill");
        setShowLogin(true);
      }
    } catch (error) {
      console.error(error);
    }
  };

  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "120px" }}>
        <h3>Loading...</h3>
      </div>
    );
  }

  if (!offer?.title) {
    return (
      <div style={{ textAlign: "center", padding: "120px" }}>
        <h3>Offer not found</h3>
      </div>
    );
  }

  return (
    <>
      <Layout />

      <div className="container-fluid pt-5 pb-3" style={{ background: "#fff" }}>
        <div className="row align-items-start">

          {/* IMAGE */}
          <div className="col-12 col-lg-5 col-md-6">
            <div style={{
              borderRadius: "10px",
              padding: "20px",
              boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              textAlign: "center"
            }}>
              <img
                src={`${BASE_URL}/${offer.image}`}
                alt={offer.title}
                className="img-fluid"
                style={{ maxHeight: "420px", objectFit: "contain" }}
              />
            </div>
          </div>

          {/* DETAILS */}
          <div className="col-12 col-lg-7 col-md-6 p-4 p-md-5 pt-md-0 pt-3">

            <span className="badge bg-danger mb-3 fs-6">
              {offer.discount} OFF
            </span>

            <h2 style={{ fontSize: "clamp(20px, 4vw, 28px)", fontWeight: 700 }}>
              {offer.title}
            </h2>

            <hr />

            {/* PRICE ROW */}
            <div className="d-flex align-items-center gap-3 mb-3 flex-wrap">
              <h1 style={{ color: "rgb(5,90,5)", fontSize: "clamp(26px, 5vw, 34px)", fontWeight: 700, margin: 0 }}>
                ₹{(offer.current_price * qty).toFixed(2)}
              </h1>
              <h4 style={{ textDecoration: "line-through", color: "#777", margin: 0 }}>
                ₹{offer.old_price}
              </h4>
            </div>

            {/* QTY */}
            <div className="d-flex align-items-center mb-4" style={{ gap: "0" }}>
              <button
                onClick={decreaseQty}
                disabled={qty <= 1}
                style={{
                  width: "40px", height: "40px",
                  border: "1px solid #ddd",
                  background: "#f8f8f8",
                  fontSize: "20px",
                  cursor: qty <= 1 ? "not-allowed" : "pointer",
                  borderRadius: "6px 0 0 6px"
                }}
              >−</button>
              <input
                type="text"
                value={qty}
                inputMode="numeric"
                pattern="[0-9]*"
                onChange={(e) => {
                  const val = e.target.value.replace(/\D/g, "");
                  if (val === "") setQty("");
                  else setQty(Math.max(1, Number(val)));
                }}
                onBlur={() => { if (!qty || qty < 1) setQty(1); }}
                style={{
                  width: "60px", textAlign: "center",
                  border: "1px solid #ddd", borderLeft: "none", borderRight: "none",
                  height: "40px", outline: "none", fontSize: "16px"
                }}
              />
              <button
                onClick={increaseQty}
                style={{
                  width: "40px", height: "40px",
                  border: "1px solid #ddd",
                  background: "#f8f8f8",
                  fontSize: "20px",
                  cursor: "pointer",
                  borderRadius: "0 6px 6px 0"
                }}
              >+</button>
            </div>

            {/* BUTTONS */}
            <div className="row g-2">
              <div className="col-6 col-md-auto">
                <button
                  onClick={handleAddToCart}
                  disabled={added}
                  style={{
                    background: "#24aeb1",
                    color: "#fff",
                    border: "none",
                    padding: "clamp(10px, 2vw, 14px) clamp(16px, 4vw, 30px)",
                    borderRadius: "8px",
                    fontWeight: 600,
                    width: "100%",
                    fontSize: "clamp(13px, 2.5vw, 15px)",
                    cursor: added ? "not-allowed" : "pointer",
                    opacity: added ? 0.85 : 1,
                    whiteSpace: "nowrap"
                  }}
                >
                  {added ? (
                    <>Added <i className="bi bi-check2 ms-1"></i></>
                  ) : (
                    <>Add to Cart <i className="bi bi-bag ms-1"></i></>
                  )}
                </button>
              </div>

              <div className="col-6 col-md-auto">
                <button
                  onClick={handleBuyNow}
                  style={{
                    background: "#24aeb1",
                    color: "#fff",
                    border: "none",
                    padding: "clamp(10px, 2vw, 14px) clamp(16px, 4vw, 30px)",
                    borderRadius: "8px",
                    fontWeight: 600,
                    width: "100%",
                    fontSize: "clamp(13px, 2.5vw, 15px)",
                    whiteSpace: "nowrap",
                    cursor: "pointer"
                  }}
                >
                  Buy Now
                </button>
              </div>
            </div>

            {/* DELIVERY TABLE */}
            <div className="pt-4">
              <table className="table table-bordered table-hover">
                <tbody>
                  <tr><td>Delivery within 3-5 working days</td></tr>
                  <tr><td>Money Back Guarantee</td></tr>
                  <tr><td>Secure Payment</td></tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>
      </div>

      {/* DESCRIPTION */}
      <div className="container-fluid px-4 px-md-5 pb-5" style={{ marginTop: "30px" }}>
        <h3 style={{ fontWeight: 600, marginBottom: "10px" }}>Description</h3>
        <hr />
        <p style={{ lineHeight: 1.7, textAlign: "justify" }}>
          {offer.description}
        </p>
      </div>

      <FooterNew />
    </>
  );
}

export default OfferDetails;